import { LabsModeSwitch } from "@/zapi-frontend/features/LabsModeSwitch";
import { UserSettings } from "./_UserSettings";
import { ChangePasswordSection } from "./ChangePasswordSection";

export function ProfileSection() {
  return (
    <div className="space-y-8">
      <UserSettings />
      <ChangePasswordSection />
      <LabsModeSwitch showDescription={true} />
    </div>
  );
}
